<template>
  <router-view />
</template>

<script setup lang="ts">
</script>

<style>
/* 全局：弹窗不超出移动端屏幕 */
.arco-modal {
  max-width: calc(100vw - 32px) !important;
}
</style>
